'use client';

import type { ListHometownNewsDto } from '@generatedapi/unauth';
import { Mousewheel } from 'swiper/modules';
import type { SwiperProps } from 'swiper/react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { RecommendHometownNewsCard } from './RecommendHometownNewsCard';
import { RecommendHometownNewsVerticalCard } from './RecommendHometownNewsVerticalCard';

interface RecommendHometownNewsProps {
  id?: string;
  list: ListHometownNewsDto[];
}

export const RecommendHometownNews = ({
  id,
  list,
}: RecommendHometownNewsProps) => {
  const listSection = {
    list: list.length < 7 ? list : list.slice(0, 3),
    swipeList: list.length < 7 ? [] : list.slice(3),
  };

  if (list.length < 1) return null;

  return (
    <article className="flex flex-col border-t-[6px] border-Gray-200 bg-Gray-white pb-30">
      <h4
        className="pb-16 pl-20 pt-32 font-700 text-Gray-900 typo-body1"
        id={id}
      >
        이런 이야기는 어때요?
      </h4>
      <ul className="mb-20 flex flex-col gap-8 px-20">
        {listSection.list.map((news) => (
          <li key={news.hometown_news_id}>
            <RecommendHometownNewsCard
              idIdx={news.hometown_news_id_idx}
              name={news.hometown_news_name}
              publishedAt={news.published_at}
              thumbnail={news.thumbnail}
            />
          </li>
        ))}
      </ul>
      {listSection.swipeList.length > 0 ? (
        <Swiper {...SWIPER_PROPS} className="m-0 mb-20 pl-20">
          {listSection.swipeList.map((news) => (
            <SwiperSlide
              key={news.hometown_news_id}
              className="w-fit last:mr-20"
            >
              <RecommendHometownNewsVerticalCard
                key={news.hometown_news_id}
                className="select-none"
                idIdx={news.hometown_news_id_idx}
                name={news.hometown_news_name}
                publishedAt={news.published_at}
                thumbnail={news.thumbnail}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : null}
    </article>
  );
};

const SWIPER_PROPS = {
  slidesPerView: 'auto',
  spaceBetween: 13,
  mousewheel: true,
  modules: [Mousewheel],
} satisfies SwiperProps;
